import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

// Returns a Set of show_ids where the user has an active race
export function useActiveRaces(userId) {
  const [raceShowIds, setRaceShowIds] = useState(new Set())
  useEffect(() => {
    if (!userId) { setRaceShowIds(new Set()); return }
    supabase.from('races').select('show_id')
      .or(`from_user.eq.${userId},to_user.eq.${userId}`)
      .eq('status','active')
      .then(({ data }) => setRaceShowIds(new Set((data||[]).map(r=>r.show_id))))
  }, [userId])
  return raceShowIds
}